export interface Technology {
  prerequisites?: string[];
}
